import React, {Component} from 'react';
import {autobind} from 'core-decorators';
import { Modal } from 'antd-mobile';
import CalendarButton  from './CalendarButton';
import tools from '../../utils/tools';
import SmoothButton from '../SmoothButton/SmoothButton';
import Calendar from '../Calendar/Calendar';
import CustomDate from './CustomDate';
import shallowCompare from 'react-addons-shallow-compare';
import './DateRangeBar.less';
import {DATE_BUTTONS} from './DateRangeButtonConfig';


const preventEvent = (event) => {
    if (event) {
        event.preventDefault();
        event.stopImmediatePropagation && event.stopImmediatePropagation();
        event.stopPropagation();
    }
};

class DateRangeBar extends Component {
    // static propTypes = {
    //   dateButtons: React.PropTypes.array,
    //   dateClick: React.PropTypes.func,
    //   dateRangeTitle: React.PropTypes.string,
    //   dateRangeValue: React.PropTypes.number,
    //   startDate: React.PropTypes.string,
    //   endDate: React.PropTypes.string,
    //   preStartDate: React.PropTypes.string,
    //   preEndDate: React.PropTypes.string,
    //   calendarBtnCls: React.PropTypes.string,
    //   hasAll: React.PropTypes.bool, //全部按钮  相当于清空的作用
    //   reportName: React.PropTypes.string, //如果想让空间支持记忆  需要传递此字段
    //   isAllInput: React.PropTypes.any
    // };

    //根据日期值获取日期名称
    getDateRangeTitleByValue(dateRangeValue){
      const {dateButtons=DATE_BUTTONS} = this.props;
      let dateRangeTitle = '';
      dateButtons.forEach((item,index)=>{
        if(item.dateRangeValue==dateRangeValue ){
          dateRangeTitle = item.dateRangeTitle;
        }
      });
      return dateRangeTitle;
    }

    constructor(props, context) {
      console.log('props:', props);
      super(props, context);
      const {dateButtons=DATE_BUTTONS,dateRangeValue='',startDate='',endDate='',reportName,isMoreCustomDate,preStartDate='',preEndDate='', ifUseDefaultData=true} = props;
      let {dateRangeTitle=''} = this.props;
      //如果有报表名字  从本地缓存中获取
      if(reportName){
        let dateInfo = tools.getCache('DateRangeBar',reportName);
        if(dateInfo){
          let openCalendar = false;
          if(dateInfo.dateRangeValue == -1){
            if(isMoreCustomDate){
              dateInfo.dateRangeTitle = '自定义';
            }

          }
          this.state={
            open: false,
            // openCustom: false,
            openCalendar: openCalendar,
            openPreCalendar: false,
            dateRangeTitle: dateInfo.dateRangeTitle,
            dateRangeValue: dateInfo.dateRangeValue,
            startDate: dateInfo.startDate,
            endDate: dateInfo.endDate,
            preStartDate:dateInfo.preStartDate,
            preEndDate:dateInfo.preEndDate,
            isVerify:true,
            errorMsgs:[]
          }
          return;
        }
      }

      if(tools.isNull(dateRangeTitle)){
        if(!tools.isNull(dateRangeValue)){
          dateRangeTitle = this.getDateRangeTitleByValue(dateRangeValue);
        }
      }
      let defaultDateRangeTitle = dateRangeTitle || '';
      let defaultDateRangeValue = dateRangeValue || -1;
      if(tools.isNull(startDate) && tools.isNull(endDate) && ifUseDefaultData){
        defaultDateRangeValue = dateRangeValue?dateRangeValue:dateButtons[1].dateRangeValue;
        defaultDateRangeTitle = dateRangeTitle?dateRangeTitle:dateButtons[1].dateRangeTitle;
      }
      this.state = {
        open: false,
        // openCustom: false,
        openCalendar: false,
        openPreCalendar: false,
        dateRangeTitle: defaultDateRangeTitle,
        dateRangeValue: defaultDateRangeValue,
        startDate: startDate,
        endDate: endDate,
        preStartDate:preStartDate,
        preEndDate:preEndDate,
        isVerify:true,
        errorMsgs:[]
      };
    }

    componentWillReceiveProps(a, b) {
      console.log(a, b)
      if (a.dateRangeTitle != b.dateRangeTitle) {
        this.setState({
          dateRangeTitle: a.dateRangeTitle
        })
      }
    }

    shouldComponentUpdate(nextProps, nextState) {
      return shallowCompare(this, nextProps, nextState);
    }

    styles() {
      return {
        iconButton: {
          minWidth: '30px',
          height: '30px'
        },
        errorItem:{
          padding: '0.2rem',
          paddingTop: '0',
          color: 'orangered'
        }
      }
    }

    @autobind
    handleCalendarDown(event,dateRange) {
      preventEvent(event);
      var _this=this;
      var inputs= document.getElementsByTagName("input");
      var length=inputs.length;
      for(let i=0;i<length;i++){
        inputs[i].blur();
      }
      setTimeout(function(){
        let open = _this.state.open;
        // let isOpenCustom = '-1' == this.state.dateRangeValue;
        _this.setState({
          open: true,
          // openCustom: isOpenCustom,
          // anchorEl: event.currentTarget
          anchorEl: document.body
        });
      },0)
    }

    @autobind
    getErroInfo(){
      const styles = this.styles();
      if(!this.state.isVerify && this.state.errorMsgs.length>0){
        return this.state.errorMsgs.map((item,index)=>{
          return(<p style = {styles.errorItem}>{item}</p>)
        });
      }
      return '';
    }

    //日期按钮组点击处理
    @autobind
    handleRequestClose(dateRangeValue = this.state.dateRangeValue, dateRangeTitle = this.state.dateRangeTitle, event) {
      console.log('dataran:', dateRangeValue);
      console.log('daterangevalue:', this.state.dateRangeValue)
      // preventEvent(event);
      if (dateRangeValue === 'clickAway') {
        this.setState({
          open: false,
        });
        return;
      }
      if(dateRangeTitle == 'clickAway'){
        this.setState({
          open: false
        });
        return;
      }


      //自定义日期特殊处理
      if(-1 == dateRangeValue){
        this.setState({
          // openCustom: !this.state.openCustom,
          dateRangeTitle: dateRangeTitle,
          dateRangeValue: dateRangeValue
        });
        this.customDateQuery();
        return;
      }

      //除自定义外的日期处理
      dateRangeTitle = (dateRangeTitle == 'clickAway' ? this.state.dateRangeTitle : dateRangeTitle);
      this.setState({
        open: false,
        // openCustom: false,
        dateRangeTitle: dateRangeTitle,
        dateRangeValue: dateRangeValue,
        startDate: '',
        endDate:'',
        preStartDate: '',
        preEndDate:'',
        isVerify:true,
        errorMsgs:[]
      });


      if(dateRangeValue !== undefined && dateRangeValue !== this.state.dateRangeValue) {
        this.setState({dateRangeValue: dateRangeValue});
        const {dateClick} = this.props;
        this._handleDateClick(dateRangeTitle,dateRangeValue,'','');
        //
        // this.state={
        //   open: false,
        //   openCustom: false,
        //   dateRangeTitle: dateInfo.dateRangeTitle,
        //   dateRangeValue: dateInfo.dateRangeValue,
        //   startDate: dateInfo.startDate,
        //   endDate: dateInfo.endDate
        // }
      }
    }

    renderItems() {
      let {dateButtons = DATE_BUTTONS,hasAll = false} = this.props;
      if(hasAll){
          const clearButtonConfig = {
            dateRangeValue: 0,
            dateRangeTitle: '全部',
            isChoosed: false,
            index: 6
          };
          dateButtons = [...dateButtons,clearButtonConfig];
      }
      return dateButtons.map((item, index) => {
        item.isChoosed = item.dateRangeValue == this.state.dateRangeValue;
        return  <SmoothButton key={`DateRangeBar_SmoothButton_${index}`} title={item.dateRangeTitle} value={item.dateRangeValue} index={item.index} isChoosed={item.isChoosed} choose={this.handleRequestClose.bind(this, item.dateRangeValue, item.dateRangeTitle)}/>;
      });
    }

    //自定义时间查询
    @autobind
    customDateClick(key,value){
      let changeState = {dateRangeValue:'-1'};
      if(tools.startWith(key,'pre')){
          changeState.openPreCalendar = true;
          changeState.openCalendar = false;
      }else{
          changeState.openCalendar = true;
          changeState.openPreCalendar = false;
      }
      this.setState(changeState);
    }

    @autobind
    customDateQuery(){

      const {isMoreCustomDate=false,isShowTimeStr = true,isAllInput = true} = this.props;
      let currentDay = tools.formatDate(new Date());
      // if(isMoreCustomDate == false){
      //   if(tools.isNull(this.state.startDate)&&tools.isNull(this.state.endDate)){
      //     setTip(true,'error',"请至少选择一个日期!");
      //     return;
      //   }
      // }
      let isVerify = true;
      let errorMsgs = [];
      if(false === isAllInput){
          if(tools.isNull(this.state.startDate)&&tools.isNull(this.state.endDate)){
            if (this.state.dateRangeValue > 0) {
              this.setState({
                open: false
              })
              return;
            }
            isVerify = false;
            errorMsgs.push("请至少选择一个日期!");
          }
      }else{
        if(!this.state.startDate || !this.state.endDate){
          isVerify = false;
          let errorMsg = "请选择完整"
          if(isMoreCustomDate){
            errorMsg +="本期";
          }
          errorMsg +="[开始时间]及[结束时间]"
          errorMsgs.push(errorMsg);
        }


        if(isMoreCustomDate){
          if(!this.state.preStartDate || !this.state.preEndDate){
            isVerify = false;
            errorMsgs.push( "请选择完整上期[开始时间]及[结束时间]");
          }

          if(this.state.startDate && this.state.preEndDate){
            var d1 = new Date(this.state.startDate);
            var d2 = new Date(this.state.preEndDate);
            if(d1<d2){
              isVerify = false;
              errorMsgs.push( "[上期时间]不能大于[本期时间]");
            }
          }
        }
      }



      this.setState({
        isVerify:isVerify,
        errorMsgs:errorMsgs
      });

      if(!isVerify){
        return;
      }

      let concatDateRangeTitle = this.state.startDate + '至' + this.state.endDate;
      if(isMoreCustomDate || !isShowTimeStr){
        concatDateRangeTitle = '自定义';
      }
      if(tools.isNull(this.state.startDate)&&tools.isNull(this.state.endDate)){
        concatDateRangeTitle = '全部';
      }
      this.setState({
        dateRangeValue: -1,
        dateRangeTitle: concatDateRangeTitle,
        open: false,
        // openCustom: false
      });



      this._handleDateClick(concatDateRangeTitle,this.state.dateRangeValue,this.state.startDate,this.state.endDate,this.state.preStartDate,this.state.preEndDate);
    }

    //本地记忆+点击事件触发
    _handleDateClick(dateRangeTitle,dateRangeValue,startDate,endDate,preStartDate,preEndDate){
      const {dateClick,reportName} = this.props;
      //本地记忆
      if(reportName){
        let cacheItem = {dateRangeTitle:dateRangeTitle,
                         dateRangeValue:dateRangeValue,
                         startDate:startDate,
                         endDate:endDate,
                         preStartDate:preStartDate,
                         preEndDate:preEndDate};
        tools.putCache('DateRangeBar',reportName,cacheItem);
      }
      if(dateClick){
        let dateParam = {DateType:dateRangeValue,StartTime:startDate,EndTime:endDate,preStartTime:preStartDate,preEndTime:preEndDate};
        dateClick(dateParam);
      }

    }

    @autobind
    _dateRangeClick(startDate,endDate){
      let changeState = {};
      if(this.state.openCalendar == true){
        changeState['startDate'] = startDate;
        changeState['endDate'] = endDate;
      }
      if(this.state.openPreCalendar == true){
        changeState['preStartDate'] = startDate;
        changeState['preEndDate'] = endDate;
      }
      if(startDate!='' && endDate!=''){
        changeState['openCalendar'] = false;
        changeState['openPreCalendar'] = false;
      }
      this.setState(changeState);
    }

    @autobind
    _modelClose(){
      this.handleRequestClose();
      this.setState({
        open:false
      });
    }

    render(e) {
        const styles = this.styles();
        const {calendarBtnCls,noBorder,isMoreCustomDate=false} = this.props;
        //{this.state.openCustom &&}
        return (
          <div className={calendarBtnCls}>
            <CalendarButton onClick={this.handleCalendarDown} dateRangeTitle={this.state.dateRangeTitle} noBorder={noBorder}/>
              <Modal
                  popup
                  wrapClassName ='dateRangeBar-modal-wrap'
                  visible={this.state.open}
                  onClose = {this._modelClose}
                  animationType="slide-down">
                <div className="dateGroup">
                  {this.renderItems()}
                </div>
                <div>{this.getErroInfo()}</div>
                {this.state.openCalendar &&<Calendar startDate={this.state.startDate} endDate={this.state.endDate}  dateClick={this._dateRangeClick}/>}
                {this.state.openPreCalendar &&<Calendar startDate={this.state.preStartDate} endDate={this.state.preEndDate}  dateClick={this._dateRangeClick}/>}
                <CustomDate startDate={this.state.startDate} endDate={this.state.endDate} preStartDate={this.state.preStartDate} preEndDate={this.state.preEndDate} dateChoose={this.customDateClick} dateQuery={this.customDateQuery} isMoreCustomDate={isMoreCustomDate}/>
            </Modal>
            {this.state.open && <div className="sort-mask"></div>}
          </div>
        );
    }
}

export default DateRangeBar;
